<template>
  <v-card flat="" outlined="">
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :loading="isLoading || fetchCount != courses.length"
      :items="courses"
      :search="search"
      sort-by="totalUsers"
      :sort-desc="true"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :footer-props="footerProps"
    >
      <template v-slot:item.action="{ item }">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <!-- eslint-disable-next-line vue/valid-v-on -->
            <v-icon small v-on="on" class="" @click="showUsers(item)">
              mdi-eye
            </v-icon>
          </template>
          <span>View Course</span>
        </v-tooltip>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import services from "@/services/index.js";
export default {
  data() {
    return {
      search: "",
      isLoading: false,
      fetchCount: 0,
      courses: [],
      userCounts: {},
      headers: [
        {
          text: "Course",
          align: "left",
          sortable: true,
          value: "name",
          width: "70%"
        },
        { text: "Users", value: "totalUsers" },
        // { text: "Unique Users", value: "users" },
        { text: "Actions", value: "action", align: "right", sortable: false }
      ],
      page: 1,
      pageCount: 0,
      itemsPerPage: 30,
      footerProps: {
        "items-per-page-options": [10, 20, 30, 40, 50, 60]
      }
    };
  },
  methods: {
    showUsers(item) {
      console.log("Going to ", item._id);
      this.$router.push({
        name: "usersbycourse",
        params: { courseid: item._id }
      });
    },
    async onLoad() {
      this.isLoading = true;
      try {
        let courses = await services.course.get({
          status: "published",
          type: "publisher"
        });
        this.courses = courses.map(course => {
          return { ...course, totalUsers: Number.NaN };
        });
      } catch (err) {
        console.error(err);
        this.isLoading = false;
        //TODO add error catching
      }
      this.courses.forEach(async course => {
        try {
          let count = await services.analytics.users.getCountByCourse({
            courseid: course._id
          });
          console.log(course._id, "totalUsers", count);
          course["totalUsers"] = count.total;
        } catch (err) {
          course["totalUsers"] = Number.NaN;
        }
        this.fetchCount++;
      });
      this.isLoading = false;
    }
  },
  created() {
    this.onLoad();
  }
};
</script>
